import React from 'react';

export default function ImgesScreen({ photos }) {
  return (
    <span style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 250px)',
      position: 'absolute',
      border: '1px solid black',
      borderTop: 'none',
      width: '80%'
      }}>
      {photos?.map(eachOne => (
        <img key={eachOne.id} src={eachOne?.url} alt="logo" style={{ padding: '20px' }} />
      ))}
    </span>
  );
}
